import {VmText, VmView} from 'components'
import React, {useEffect, useRef, useState} from 'react'
import {useParams, useNavigate} from 'react-router-dom'
import VmHeader from 'components/layout/VmHeader'
import {VmFab, VmList, VmPicker} from 'components'
import {tglDDMMMYYYY, toCurrency} from 'utils/functions'
import VmIndexRead from 'components/template/VmIndexRead'
import axios from 'axios'
import QueryString from 'qs'
import AlertYesNo from 'components/AlertYesNo'
import AlertOk from 'components/AlertOk'
import {Navigate, redirect, useSearchParams} from 'react-router-dom'
import {
  VmCheckIcon,
  VmMagnifyingGlassIcon,
  VmPlusIcon,
  VmTrashIcon,
} from 'components/icons/solid'
import {API, graphqlOperation} from 'aws-amplify'
import {mAktifkanDiagnosa, mDeleteDiagnosa} from 'graphql/mutations'
import DatePicker, {registerLocale} from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import id from 'date-fns/locale/id'
import {removeLclStorage, setLclStorage} from 'utils/localstorage'
registerLocale('id', id)

const {REACT_APP_BASE_URL_DOKTER: BASE_URL} = process.env

export default function PilihPasien() {
  const fieldsDesktop = [
    {
      key: 'pastglreg',
      label: 'Tgl Registrasi',
      _style: {fontWeight: 'bold'},
      className: 'text-[#3B82F6]',
      sorter: true,
      type: 'date',
      filterType: 'none',
      _classes: 'min-w-[160px]',
    },
    {
      key: 'pasrm',
      label: 'No. RM',
      _style: {fontWeight: 'bold', className: 'text-[#3b82f6]'},
    },
    {
      key: 'pasnobpjs',
      label: 'No. BPJS',
      _style: {fontWeight: 'bold', className: 'text-[#3b82f6]'},
    },
    {
      key: 'pasnokk',
      label: 'No. KK',
      _style: {fontWeight: 'bold', className: 'text-[#3b82f6]'},
    },
    {
      key: 'pasnoktp',
      label: 'NIK',
      _style: {fontWeight: 'bold', className: 'text-[#3b82f6]'},
      // filterType: 'none',
      sorter: false,
    },
    {
      key: 'pasnama',
      label: 'Nama Pasien',
      _style: {fontWeight: 'bold', className: 'text-[#3b82f6]'},
    },
    {
      key: 'pastgllahir',
      label: 'Tgl Lahir',
      _style: {fontWeight: 'bold', className: 'text-[#3b82f6]'},
      type: 'date',
      filterType: 'datepicker',
    },
    {
      key: 'pasid_satusehat',
      label: 'ID Satu Sehat',
      _style: {fontWeight: 'bold', className: 'text-[#3b82f6]'},
    },
    {
      key: 'pasgoldarah',
      label: 'Golongan Darah',
      _style: {fontWeight: 'bold', className: 'text-[#3b82f6]'},
    },
    {
      key: 'pasjk',
      label: 'Jenis Kelamin',
      _style: {fontWeight: 'bold', className: 'text-[#3b82f6]'},
      filterType: 'select',
      filterValue: [
        {value: 'Semua', text: 'Semua'},
        {value: 'Laki-laki', text: 'Laki-laki'},
        {value: 'Perempuan', text: 'Perempuan'},
      ],
      _classes: 'min-w-[160px]',
    },
    {
      key: 'pasalamat',
      label: 'Alamat Lengkap',
      _style: {fontWeight: 'bold', className: 'text-[#3b82f6]'},
    },
    {
      key: 'pastelp',
      label: 'No. WA',
      _style: {fontWeight: 'bold', className: 'text-[#3b82f6]'},
    },
    {
      key: 'pasagama',
      label: 'Agama',
      _style: {fontWeight: 'bold', className: 'text-[#3b82f6]'},
      sorter: false,
      filterType: 'none',
    },
    {
      key: 'paspendidikan',
      label: 'Pendidikan',
      _style: {fontWeight: 'bold', className: 'text-[#3b82f6]'},
      sorter: false,
      filterType: 'none',
    },
    {
      key: 'paspekerjaan',
      label: 'Pekerjaan',
      _style: {fontWeight: 'bold', className: 'text-[#3b82f6]'},
    },
    {
      key: 'pasalergi',
      label: 'Alergi Obat',
      _style: {fontWeight: 'bold', className: 'text-[#3b82f6]'},
    },
    {
      key: 'pasalergimakanan',
      label: 'Alergi Makanan',
      _style: {fontWeight: 'bold', className: 'text-[#3b82f6]'},
    },
    {
      key: 'pasaktif',
      type: 'map',
      mapValue: {1: 'Aktif', 2: 'Non Aktif'},
      label: 'Status',
      _style: {fontWeight: 'bold'},
      className: 'text-[#3B82F6] pb-2 border-blue-500 border-b-2',
      sorter: false,
      filterType: 'select',
      filterValue: [
        {value: 1, text: 'Aktif'},
        {value: 2, text: 'Non Aktif'},
      ],
      _classes: 'min-w-[160px]',
      // containerClassName: '',
    },
  ]

  const navigate = useNavigate()
  const params = useParams()
  const uid = params.id
  const alertyesno = useRef()
  const alertok = useRef()
  const [searchParams, setSearchParams] = useSearchParams()
  let from = searchParams.get('from')
  let pasid_exception = searchParams.get('pasid_exception')

  const [ubahId, setubahId] = useState(0)
  const [tambah, settambah] = useState(false)
  const [ubah, setubah] = useState(false)
  const [limit, setlimit] = useState(10) // Limit data per pag)
  const [data, setdata] = useState([])
  const [itemsCount, setitemsCount] = useState(0)

  const [fetchingMore, setfetchingMore] = useState(false)
  const [gettingInitialData, setgettingInitialData] = useState(true)
  const [hasMoreItems, sethasMoreItems] = useState(true)

  // Device-nya hanya dibuat mobile, karena registrasi pasien via web memang hanya diakses lewat desktop
  const [device, setdevice] = useState('web') // Bisa Web (Tabel) / Mobile (List)
  const [cari, setcari] = useState('') // Value pencarian use)
  const [pasaktif, setpasaktif] = useState(1) // Filter flag statu)

  // Filter untuk pencarian web
  const [sort, setsort] = useState('pastglreg asc')
  const [activePage, setactivePage] = useState(1)

  const [pasrm, setpasrm] = useState('')
  const [pasnobpjs, setpasnobpjs] = useState('')
  const [pasnokk, setpasnokk] = useState('')
  const [pasnoktp, setpasnoktp] = useState('')
  const [pasnama, setpasnama] = useState('')
  const [pastgllahir, setpastgllahir] = useState('')
  const [pasid_satusehat, setpasid_satusehat] = useState('')
  const [pasgoldarah, setpasgoldarah] = useState('')
  const [pasjk, setpasjk] = useState('')
  const [pasalamat, setpasalamat] = useState('')
  const [pastelp, setpastelp] = useState('')
  const [agnama, setagnama] = useState('')
  const [pendnama, setpendnama] = useState('')
  const [paspekerjaan, setpaspekerjaan] = useState('')
  const [pasalergi, setpasalergi] = useState('')
  const [pasalergimakanan, setpasalergimakanan] = useState('')
  const [refreshcount, setrefreshcount] = useState(0)

  useEffect(() => {
    // console.log('useEffect getInitialData', {from, pasid_exception})
    removeLclStorage('regpasien_nokunjungan', {type: 2})
    removeLclStorage('regpasien_tanggalkunjungan', {type: 2})
    removeLclStorage('regpasien_keluhan', {type: 2})
    getInitialData()
    return () => {}
  }, [
    activePage,
    sort,
    pasrm,
    pasnobpjs,
    pasnokk,
    pasnoktp,
    pasnama,
    pastgllahir,
    pasid_satusehat,
    pasgoldarah,
    pasjk,
    pasalamat,
    pastelp,
    agnama,
    pendnama,
    paspekerjaan,
    pasalergi,
    pasalergimakanan,
    pasaktif,
    refreshcount,
  ])

  const getInitialData = () => {
    let params = {
      a: 'dk13',
      uid,
      pasaktif,
      device,
      limit,
    }
    let offset = (activePage - 1) * limit
    params = {
      ...params,
      offset,
      pasrm,
      pasnobpjs,
      pasnokk,
      pasnoktp,
      pasnama,
      pastgllahir,
      pasid_satusehat,
      pasgoldarah,
      pasjk: pasjk == 'Semua' ? '' : pasjk, // Kalao semua maka gk usah kirim value
      pasalamat,
      pastelp,
      agnama,
      pendnama,
      paspekerjaan,
      pasalergi,
      pasalergimakanan,
      sorting: sort,
      pasid_exception,
    }

    setgettingInitialData(true)
    axios
      .post(
        `${BASE_URL}/pasien-v2/mobile-pasien`,
        QueryString.stringify(params)
      )
      .then(({data: res}) => {
        // console.log('Data Registrasi Pasien', res)
        setdata(res)
        setLclStorage('regpasien_data', JSON.stringify(res), {type: 2})

        if (res.length < 10) {
          sethasMoreItems(false)
        } else {
          sethasMoreItems(true)
        }
      })
      .catch(err => {
        console.log('Error get Data Registrasi Pasien', err.message)
      })
      .finally(() => {
        setgettingInitialData(false)
      })

    axios
      .post(
        `${BASE_URL}/pasien-v2/mobile-pasien-count`,
        QueryString.stringify(params)
      )
      .then(({data: res}) => {
        // console.log('Data Registrasi Pasien', res)
        setitemsCount(res.total)
      })
      .catch(err => {
        console.log('Error get Data Registrasi Pasien count', err.message)
      })
  }

  const fetchMore = () => {}

  const hapus = item => {
    let params = {
      a: 'dk13',
      reg: 'db',
    }
    axios
      .post(
        `${BASE_URL}/pasien-v2/hapus?id=${item.pasid}`,
        QueryString.stringify(params)
      )
      .then(({data: res}) => {
        // console.log('Data Registrasi Pasien', res)

        if (res.status == 0) {
          alertok.current?.show({
            message: res.message,
            type: 'warning',
          })
          return
        }
        alertok.current?.show({
          message: 'Berhasil hapus pasien',
          type: 'success',
        })
        refreshAfterActivateOrDelete()
      })
      .catch(err => {
        console.log('Error get Data Registrasi Pasien', err.message)
      })
      .finally(() => {
        setgettingInitialData(false)
      })
  }

  const aktifkan = item => {
    let params = {
      a: 'dk13',
      reg: 'db',
    }
    axios
      .post(
        `${BASE_URL}/pasien-v2/aktif?id=${item.pasid}`,
        QueryString.stringify(params)
      )
      .then(({data: res}) => {
        // console.log('Data Registrasi Pasien', res)

        alertok.current?.show({
          message: 'Berhasil aktifkan pasien',
          type: 'success',
        })
        refreshAfterActivateOrDelete()
      })
      .catch(err => {
        console.log('Error get Data Registrasi Pasien', err.message)
      })
      .finally(() => {
        setgettingInitialData(false)
      })
  }

  const select = item => {
    switch (from) {
      case 'index':
        // Jika Dari Index Registrasi Pasien
        setLclStorage('regpasien_pasid', item.pasid, {type: 2})
        setLclStorage('regpasien_pasnobpjs', item.pasnobpjs, {type: 2})
        setLclStorage('regpasien_pasnokk', item.pasnokk, {type: 2})
        setLclStorage('regpasien_pasnama', item.pasnama, {type: 2})
        setLclStorage('regpasien_pasgoldarah', item.pasgoldarah, {type: 2})
        setLclStorage('regpasien_pasjk', item.pasjk, {type: 2})
        setLclStorage('regpasien_pastgllahir', item.pastgllahir, {type: 2})
        setLclStorage('regpasien_pasalamat', item.pasalamat, {type: 2})
        setLclStorage('regpasien_pasidkec', item.idkecamatan, {type: 2})
        setLclStorage('regpasien_pastelp', item.pastelp, {type: 2})
        setLclStorage('regpasien_paspekerjaan', item.paspekerjaan, {type: 2})
        setLclStorage('regpasien_pasemail', item.pasemail, {type: 2})
        setLclStorage('regpasien_pasalergi', item.pasalergi, {type: 2})
        setLclStorage('regpasien_pasalergimakanan', item.pasalergimakanan, {
          type: 2,
        })
        setLclStorage('regpasien_pasnoktp', item.pasnoktp, {type: 2})
        setLclStorage('regpasien_pasrm', item.pasrm, {type: 2})
        setLclStorage('regpasien_pasid_satusehat', item.pasid_satusehat, {
          type: 2,
        })
        setLclStorage('regpasien_pasconsent', item.pasconsent.toString(), {
          type: 2,
        })
        setLclStorage('regpasien_pasumur', item.umur, {type: 2})
        setLclStorage('regpasien_agid', item.agid, {type: 2})
        setLclStorage('regpasien_pendid', item.pendid, {type: 2})

        setLclStorage('regpasien_penid', item.penid, {type: 2})
        setLclStorage('regpasien_pennama', item.pennama, {type: 2})
        setLclStorage('regpasien_pennik', item.pennik, {type: 2})
        setLclStorage('regpasien_penhubungan', item.penhubungan, {type: 2})
        setLclStorage('regpasien_penjk', item.penjk, {type: 2})
        setLclStorage('regpasien_pentelp', item.pentelp, {type: 2})
        setLclStorage('regpasien_penalamat', item.penalamat, {type: 2})
        break

      case 'tambah_pasien':
        // Replace local storage data penanggungjawab
        setLclStorage('regpasien_tambah_pennama', item.pasnama, {type: 2})
        setLclStorage('regpasien_tambah_pennik', item.pasnoktp, {type: 2})
        setLclStorage('regpasien_tambah_penjk', item.pasjk, {type: 2})
        setLclStorage('regpasien_tambah_pentelp', item.pastelp, {type: 2})
        setLclStorage('regpasien_tambah_penalamat', item.pasalamat, {type: 2})
        setLclStorage(
          'regpasien_tambah_penpasienpenanggungjawab',
          `${item.pasrm} - ${item.pasnama}`,
          {type: 2}
        )
        break

      case 'ubah_pasien':
        // Replace local storage data penanggungjawab
        setLclStorage('regpasien_ubah_pennama', item.pasnama, {type: 2})
        setLclStorage('regpasien_ubah_pennik', item.pasnoktp, {type: 2})
        setLclStorage('regpasien_ubah_penjk', item.pasjk, {type: 2})
        setLclStorage('regpasien_ubah_pentelp', item.pastelp, {type: 2})
        setLclStorage('regpasien_ubah_penalamat', item.pasalamat, {type: 2})
        setLclStorage(
          'regpasien_ubah_penpasienpenanggungjawab',
          `${item.pasrm} - ${item.pasnama}`,
          {type: 2}
        )
        break

      default:
        break
    }

    // navigate('/prd-registrasi-pasien/' + uid)
    // Navigate Back Saja.
    navigate(-1)
  }

  const edit = item => {
    console.log('edit ', item)
    // Set Local Storage
    setLclStorage('regpasien_ubah_pasid', item.pasid, {type: 2})
    setLclStorage('regpasien_ubah_pasnobpjs', item.pasnobpjs, {type: 2})
    setLclStorage('regpasien_ubah_pasnokk', item.pasnokk, {type: 2})
    setLclStorage('regpasien_ubah_pasnama', item.pasnama, {type: 2})
    setLclStorage('regpasien_ubah_pasgoldarah', item.pasgoldarah, {type: 2})
    setLclStorage('regpasien_ubah_pasjk', item.pasjk, {type: 2})
    setLclStorage('regpasien_ubah_pastgllahir', item.pastgllahir, {type: 2})
    setLclStorage('regpasien_ubah_pasalamat', item.pasalamat, {type: 2})
    setLclStorage('regpasien_ubah_pasidkec', item.idkecamatan, {type: 2})
    setLclStorage('regpasien_ubah_idprovinsi', item.idprovinsi, {type: 2})
    setLclStorage('regpasien_ubah_idkota', item.idkota, {type: 2})
    setLclStorage('regpasien_ubah_provinsi', item.provinsi, {type: 2})
    setLclStorage('regpasien_ubah_kota', item.kota, {type: 2})
    setLclStorage('regpasien_ubah_kecamatan', item.kecamatan, {type: 2})
    setLclStorage('regpasien_ubah_pastelp', item.pastelp, {type: 2})
    setLclStorage('regpasien_ubah_paspekerjaan', item.paspekerjaan, {type: 2})
    setLclStorage('regpasien_ubah_pasemail', item.pasemail, {type: 2})
    setLclStorage('regpasien_ubah_pasalergi', item.pasalergi, {type: 2})
    setLclStorage('regpasien_ubah_pasalergimakanan', item.pasalergimakanan, {
      type: 2,
    })
    setLclStorage('regpasien_ubah_pasnoktp', item.pasnoktp, {type: 2})
    setLclStorage('regpasien_ubah_pasrm', item.pasrm, {type: 2})
    setLclStorage('regpasien_ubah_pasid_satusehat', item.pasid_satusehat, {
      type: 2,
    })
    setLclStorage('regpasien_ubah_pasconsent', item.pasconsent.toString(), {
      type: 2,
    })
    setLclStorage('regpasien_ubah_pasumur', item.umur, {type: 2})
    setLclStorage('regpasien_ubah_agid', item.agid, {type: 2})
    setLclStorage('regpasien_ubah_pendid', item.pendid, {type: 2})

    setLclStorage('regpasien_ubah_penid', item.penid, {type: 2})
    setLclStorage('regpasien_ubah_pennama', item.pennama, {type: 2})
    setLclStorage('regpasien_ubah_pennik', item.pennik, {type: 2})
    setLclStorage('regpasien_ubah_penhubungan', item.penhubungan, {type: 2})
    setLclStorage('regpasien_ubah_penjk', item.penjk, {type: 2})
    setLclStorage('regpasien_ubah_pentelp', item.pentelp, {type: 2})
    setLclStorage('regpasien_ubah_penalamat', item.penalamat, {type: 2})
    setLclStorage('regpasien_ubah_penpasienpenanggungjawab', ``, {type: 2})

    navigate(
      '/prd-registrasi-pasien/tambah-pasien/' + uid + '?mode=ubah_pasien'
    )
  }

  const refreshAfterActivateOrDelete = () => {
    setrefreshcount(prev => prev + 1)
  }

  return (
    <VmView>
      <AlertYesNo ref={alertyesno} />
      <AlertOk ref={alertok} />
      <VmIndexRead
        headerTitle={'Data Registrasi Pasien'}
        items={data}
        itemsCount={itemsCount}
        fields={fieldsDesktop} // Karena device sudah pasti dari web, maka gunakan fieldDesktop langsung.
        listItemContainerClassName={'p-4 border shadow-lg m-4 rounded'}
        listSearchbar={{placeholder: 'Cari Data Registrasi Pasien'}}
        // listSearchbarLeft={<p>Test halo</p>}
        listSearchbarRight={
          <VmPicker
            style={{
              // flex: 0.2,
              background:
                'url(https://cdn-icons-png.flaticon.com/512/32/32195.png) var(--sizeIco) no-repeat #FFF',
              paddingRight: '4px !important',
              paddingLeft: '4px',
            }}
            items={[
              {value: 1, text: 'Aktif'},
              {value: 2, text: 'Non Aktif'},
            ]}
            onChange={e => {
              let val = e.target.value
              // this.setState({pasaktif: val}, this.getInitialData)
              setpasaktif(val)
              // console.log('onChange gan', val)
            }}
            placeholder={null}
            value={pasaktif}
            className="rounded-xl text-sm mb-2 py-2"
          />
        }
        listSearchbarClassname="mr-2" // Class Untuk inputan filter search bar
        onItemPress={item => {}}
        editButton={item => {
          // Menampilkan button hanya untuk data yang pasaktifnya == 1
          return item.pasaktif == 1
        }}
        deleteButton={item => {
          // Menampilkan button hanya untuk data yang pasaktifnya == 1
          return item.pasaktif == 1
        }}
        customButton={item => {
          // Menampilkan button hanya untuk data yang pasaktifnya == 1
          if (item.pasaktif == 1) return
          return (
            <div
              onClick={() => {
                aktifkan(item)
              }}
              className="flex flex-1 items-center justify-center rounded bg-green-500 ml-2 py-1"
            >
              <VmCheckIcon color="white" height={`${24}px`} width={`${24}px`} />
              <p className="text-white">Aktifkan</p>
            </div>
          )
        }}
        onEditItemPress={item => {
          // this.setState({ubahId: item.pasid, ubah: true})
          edit(item)
        }}
        onDeleteItemPress={item => {
          alertyesno.current?.show(
            {message: `Apakah anda yakin ingin menghapus ${item.pasnama}?`},
            () => {
              hapus(item)
            }
          )
        }}
        // Start List Props
        hasMoreItems={hasMoreItems}
        loadMore={() => {
          // console.log('Load More', fetchingMore, gettingInitialData)
          // Jika sedang load new data / get Initial data maka ndak perlu panggil fetchMore lagi (Antisipasi data ndobel)
          if (!fetchingMore && !gettingInitialData) fetchMore()
        }}
        // End List Props
        // Start Table Props

        // End Table Props
        onFabPress={() => {
          // console.log('Fab Press')
          navigate(
            '/prd-registrasi-pasien/tambah-pasien/' +
              uid +
              '?mode=tambah_pasien'
          )
        }}
        device={device}
        onSearchSubmit={value => {
          setcari(value)
          // this.cari(value)
        }}
        /**
         * Parameter Untuk DataTable (Versi Desktop Web)
         */
        showEditAction={from == 'index'} // Hanya tampilkan tombol edit kalau dari index
        showDeleteAction={from == 'index'} // Hanya tampilkan tombol hapus kalau dari index
        loadingFetchData={gettingInitialData}
        totalPage={Math.ceil(itemsCount / 10)}
        activePage={activePage}
        onActivePageChange={page => {
          console.log('page change gan ', page)
          // this.setState({activePage: page}, this.getInitialData)
          setactivePage(page)
        }}
        onColumnFilterChange={data => {
          console.log('onColumnFilterChange ', data)

          // let prevFilter = {
          //   paskode: paskode,
          //   pasnama: pasnama,
          //   pasket: pasket,
          //   pasaktif: pasaktif,
          // }
          // if (JSON.stringify(data) != JSON.stringify(prevFilter)) {
          //   // Search hanya jika value filter kolom ada yang berubah
          //   this.setState({...data, activePage: 1}, this.getInitialData)
          // }

          setactivePage(1)
          setpasaktif(data.pasaktif)
          setpasrm(data.pasrm)
          setpasnobpjs(data.pasnobpjs)
          setpasnokk(data.pasnokk)
          setpasnoktp(data.pasnoktp)
          setpasnama(data.pasnama)
          setpastgllahir(data.pastgllahir)
          setpasid_satusehat(data.pasid_satusehat)
          setpasgoldarah(data.pasgoldarah)
          setpasjk(data.pasjk)
          setpasalamat(data.pasalamat)
          setpastelp(data.pastelp)
          setagnama(data.agnama)
          setpendnama(data.pendnama)
          setpaspekerjaan(data.paspekerjaan)
          setpasalergi(data.pasalergi)
          setpasalergimakanan(data.pasalergimakanan)
        }}
        onSorterValueChange={sortData => {
          // this.setState(
          //   {sort: `${sortData.column} ${sortData.asc ? 'asc' : 'desc'}`},
          //   this.getInitialData
          // )

          setsort(`${sortData.column} ${sortData.asc ? 'asc' : 'desc'}`)
          console.log('onSorterValueChange', sortData)
        }}
        totalCount={itemsCount}
        title="Data Registrasi Pasien"
        onRefreshPress={() => {
          // Reset filter, sorting & paging
          setpasrm('')
          setpasnobpjs('')
          setpasnokk('')
          setpasnoktp('')
          setpasnama('')
          setpastgllahir('')
          setpasid_satusehat('')
          setpasgoldarah('')
          setpasjk('')
          setpasalamat('')
          setpastelp('')
          setagnama('')
          setpendnama('')
          setpaspekerjaan('')
          setpasalergi('')
          setpasalergimakanan('')
          setpasaktif(1)
          setactivePage(1)
          setsort('pastglreg asc')
        }}
        columnFilterValue={{
          pasnama: '',
          pasaktif: 1,
          pasrm: '',
          pasnobpjs: '',
          pasnokk: '',
          pasnama: '',
          pastgllahir: '',
          pasid_satusehat: '',
          pasgoldarah: '',
          pasjk: '',
          pasalamat: '',
          pastelp: '',
          agnama: '',
          pendnama: '',
          paspekerjaan: '',
          pasalergi: '',
          pasalergimakanan: '',
        }}
        sorterValue={{column: 'pastglreg', asc: true}}
        statusColName="pasaktif"
        onActivate={item => aktifkan(item)}
        selectionTable
        onSelect={item => {
          console.log('onSelect ', item)
          select(item)
        }}
        backButton
        onBackPress={() => navigate(-1)}
      />
    </VmView>
  )
}
